<template>
  <div class="p2p-media-box" :style="boxStyle">
    <video v-if="isVideo && url" :src="url" :poster="posterUrl" controls playsinline preload="metadata" class="p2p-media-el"></video>
    <img v-else-if="url" :src="url" :alt="alt" class="p2p-media-el" :style="{ objectFit: fit }" @load="$emit('load')">
    <div v-else-if="failed" class="p2p-media-failed">Preview unavailable</div>
    <div v-else class="p2p-skeleton p2p-media-el" :style="{ minHeight: '100%' }"></div>
  </div>
</template>

<script>
import { mediaUrl } from '../api';

export default {
  name: 'MediaImg',
  props: {
    src: { type: String, default: '' },
    poster: { type: String, default: '' },
    kind: { type: String, default: 'image' },
    alt: { type: String, default: '' },
    ratio: { type: String, default: '' },
    fit: { type: String, default: 'cover' }
  },
  data: () => ({ url: '', posterUrl: '', failed: false }),
  computed: {
    isVideo() { return this.kind === 'video'; },
    boxStyle() { return this.ratio ? { aspectRatio: this.ratio } : {}; }
  },
  watch: {
    src: { immediate: true, handler() { this.load(); } }
  },
  methods: {
    async load() {
      this.url = '';
      this.failed = false;
      if (!this.src) return;
      try {
        if (this.isVideo && this.poster) this.posterUrl = await mediaUrl(this.poster);
        this.url = await mediaUrl(this.src);
      } catch (error) {
        this.failed = true;
      }
    }
  }
};
</script>

<style>
.p2p-media-box{position:relative;width:100%;overflow:hidden;border-radius:12px;background:#0f1320}
.p2p-media-el{display:block;width:100%;height:100%}
.p2p-media-box[style*="aspect-ratio"] .p2p-media-el{position:absolute;inset:0}
.p2p-media-failed{display:grid;place-items:center;min-height:120px;height:100%;color:var(--p2p-faint);font-size:13px}
</style>
